export * from "./LocalStorage";
export * from "./mapData";

export const downloadFile = (fileUrl = "") => {
  const isFileUrlIValid = typeof fileUrl !== "string" || !fileUrl.trim();
  if (isFileUrlIValid) {
    console.error("fileUrl must be string, but got ", fileUrl);
    return;
  }
  const linkElement = document.createElement("a");
  linkElement.setAttribute("download", "");
  linkElement.href = fileUrl;
  linkElement.click();
  linkElement.remove();
};
